module.exports = __webpack_public_path__ + "static/media/passport.da693b4d.svg";